<template>
  <div v-if="forCreation" :class="$style.title">
    Контактные данные контрагента
  </div>
  <div :class="[$style.container, { [$style.readonly]: readonly }]">
    <div :class="$style.column">
      <div :class="[$style.input]">
        <input
          v-model="form.legal_address"
          type="text"
          @input="
            $store.commit('setProjectsField', {
              field: 'legal_address',
              value: form.legal_address,
            })
          "
          placeholder="Юридический адрес"
        />
      </div>
      <div :class="$style.input">
        <input
          v-model="form.actual_address"
          @input="
            $store.commit('setProjectsField', {
              field: 'actual_address',
              value: form.actual_address,
            })
          "
          type="text"
          placeholder="Фактический адрес"
        />
      </div>
      <div
        :class="[
          $style.input,
          { [$style.error]: errors && errors.phone_number },
        ]"
      >
        <input
          v-model="form.phone_number"
          type="text"
          @input="
            $store.commit('setProjectsField', {
              field: 'phone_number',
              value: form.phone_number,
            })
          "
          placeholder="Телефон"
        />
      </div>
    </div>
    <div :class="$style.column">
      <div
        :class="[
          $style.input,
          {
            [$style.error]: errors && errors.additional_phone_number,
          },
        ]"
      >
        <input
          v-model="form.additional_phone_number"
          type="text"
          @input="
            $store.commit('setProjectsField', {
              field: 'additional_phone_number',
              value: form.additional_phone_number,
            })
          "
          placeholder="Дополнительный телефон"
        />
      </div>
      <div :class="$style.input">
        <input
          v-model="form.email"
          @input="
            $store.commit('setProjectsField', {
              field: 'email',
              value: form.email,
            })
          "
          type="text"
          placeholder="E-mail"
        />
      </div>
      <div :class="[$style.input]">
        <input
          v-model="form.web_site"
          @input="
            $store.commit('setProjectsField', {
              field: 'web_site',
              value: form.web_site,
            })
          "
          type="text"
          :placeholder="'Сайт'"
        />
      </div>
    </div>
    <div :class="$style.column">
      <div :class="$style.textarea">
        <textarea
          v-model="form.note"
          @input="
            $store.commit('setProjectsField', {
              field: 'note',
              value: form.note,
            })
          "
          placeholder="Примечание"
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    forCreation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: JSON.parse(JSON.stringify(this.project)),
      isLoad: false,
      errors: [],
    };
  },
  computed: {
    allErrors() {
      return this.$store.state.errors.errors[0];
    },
  },
  watch: {
    project() {
      this.form = JSON.parse(JSON.stringify(this.project));
    },
    allErrors() {
      this.errors = this.allErrors;
    },
  },
};
</script>

<style lang="scss" module>
.title {
  @include Subtitle;
  margin: 0 0 1rem 0;
}
.container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  &.readonly {
    pointer-events: none;
    textarea {
      pointer-events: all;
      @include scrollbarY;
    }
  }
  .column {
    .phones {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
    }
    .input {
      margin: 0 0 1rem 0;

      &:last-child {
        margin: 0;
      }
      input {
        width: 100%;
        padding: 0.75rem 1rem;
        border-radius: 0.25rem;
        background-color: $bg-secondary;
        outline: 0;
        border: none;
        @include Body1;
        &::placeholder {
          @include Body1;
          color: $t-secondary;
        }
      }
      &.error {
        input {
          border: 1px solid $red;
        }
      }
    }
    .textarea {
      height: 100%;
      textarea {
        width: 100%;
        height: 100%;
        background-color: $bg-secondary;
        border: none;
        outline: 0;
        padding: 0.75rem 1rem;
        @include Body1;
        &::placeholder {
          @include Body1;
          color: $t-secondary;
        }
      }
    }
  }
}
</style>
